import {ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {AuthService, provideEntityModel} from "@fedeltapointofsale/data-client";
import {EmployeeEntityModel} from "../employee-entity.model";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {Subscription} from "rxjs";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-employee-edit-page",
    templateUrl: "./employee-edit-page.component.html",
    providers: [provideEntityModel(EmployeeEntityModel)]
})
export class EmployeeEditPageComponent extends AbstractEditPage implements OnDestroy {

    private subscriptions: Subscription = new Subscription();

    constructor(public model: EmployeeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService,
                private authService: AuthService) {
        super(changeDetectorRef, responsiveService);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
